import axios from 'axios'

function issueValidateKey(organization, purpose) {
  return axios.post(`${process.env.VUE_APP_SERVER}/openapi/accessKey/issue`, {
    organization: organization,
    purpose: purpose
  });
}

function createOpenApiUrlByMngNo(type, statId, validateKey) {
  const typeCode = type === 'subject' ? '01' : '02';
  return createUrl('getStatsInfo', typeCode, null, statId, validateKey);
}

function createOpenApiUrlByClsfNo(type, clsfNo, validateKey) {
  const typeCode = type === 'subject' ? '01' : '02';
  return createUrl('getStatsInfo', typeCode, clsfNo, null, validateKey);
}

function createUrl(method, typeCode, statsClsfNo, statsMngNo, validateKey) {
  const url = `${window.location.origin}/portal/openapi/stats/${method}`;
  let param = `?statsType=${typeCode}`;

  switch (method) {
    case 'getStatsInfo':
      if (statsClsfNo) {
        param += `&statsClsfNo=${statsClsfNo}`
      } else if (statsMngNo) {
        if (Array.isArray(statsMngNo))
          param += `&statsMngNo=${statsMngNo.join(',')}`;
        else
          param += `&statsMngNo=${statsMngNo}`;
      }

      break;
  }

  return url + param + `&ctfcnVl=${validateKey}`;
}

function getStatsInfo(url) {
  return axios.get(url);
}

export {issueValidateKey, createOpenApiUrlByMngNo, createOpenApiUrlByClsfNo, getStatsInfo}
